import { api_get, api_post } from '../../../utils/http'

const baseUri = '/search/api'

/**
 * 1.是否已经开通会员
 */
function getOpenInfoApi(params: any) {
  return api_get(baseUri + '/personal/membership/hover', params)
}

/**
 * 3.获取用户信息（个人中心）
 */
function getUserInfo(params: any) {
  return api_get(baseUri + '/personal/user-info', params)
}

/**
 * 4.获取我的下载
 */
function getMyDownload(params: any) {
  return api_post(baseUri + '/personal/download/list', params)
}

/**
 * 5.获取用户的所有会员卡信息
 */
function getAllCards(params: any) {
  return api_post(baseUri + '/personal/membership/list', params)
}
/**
 * 6.获取订单信息
 */
function getOrderList(params: any) {
  return api_post(baseUri + '/personal/order/list', params)
}
/**
 * 7.获取修改个人信息页的选项信息
 */
function getChoicesInfo(params: any) {
  return api_post(baseUri + '/personal/user-info/choice', params)
}
/**
 * 8.修改个人信息
 */
function modifySelfInfo(params: any) {
  return api_post(baseUri + '/personal/user-info', params)
}
/**
 * 9.获得最新的用户信息
 */
function getCurrentUserInfo(params: any) {
  return api_post(baseUri + '/auth/user-info', params)
}
/**
 * 10.查询试卷文档
 */
function paperDoc(params: any) {
  return api_get(baseUri + '/paper/doc', params)
}
/**
 * 11.获取个人列表
 */
function getPersonMemeberList(params: any) {
  return api_get(baseUri + '/personal/invitation/list', params)
}
/**
 * 12.获取下载列表
 */
function getDownloadList(params: any) {
  return api_post(baseUri + '/cms_resource/download/list', params)
}
/**
 * 12.获取下载列表
 */
function getSyncList(params: any) {
  return api_post(baseUri + '/personal/sync/list', params)
}

export {
  getOpenInfoApi,
  getMyDownload,
  getUserInfo,
  getAllCards,
  getOrderList,
  getChoicesInfo,
  modifySelfInfo,
  getCurrentUserInfo,
  paperDoc,
  getPersonMemeberList,
  getDownloadList,
  getSyncList
}
